<script setup lang="ts">
import { useFormStore } from '@/stores/form';
import { useUserStore } from '@/stores/user';

const formStore = useFormStore();
const userStore = useUserStore();

function gohome() {
  if (userStore.isLoggedIn) {
    formStore.switchForm('video');
  } else {
    formStore.switchForm('login');
  }
}

function scrollToQuestion(event: Event) {
  const targetId = (event.target as HTMLSelectElement).value;
  const el = document.getElementById(targetId);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
}
</script>

<template>
  <div class="container">
    <div class="content">

      <h1 style="color: #fff;">4K雲端錄影出貨系統</h1>
      <p style="margin-bottom: 1rem;">歡迎使用，從以下教學開始：</p>

      <!-- 下拉選單 -->
      <select @change="scrollToQuestion($event)">
        <option disabled selected>📋 選擇想了解的問題</option>
        <option value="q1">如何開始？</option>
        <option value="q2">為什麼選擇 虔智科出貨錄影系統？</option>
        <option value="q3">有哪些核心功能？</option>
        <option value="q4">支援格式與硬體建議？</option>
        <option value="q5">解析度比較差異？</option>
        <option value="q6">適用場景有哪些？</option>
        <option value="q7">使用後有哪些優勢？</option>
      </select>

      <!-- FAQ 1：影片教學 -->
      <section id="q1">
        <h2>如何開始？</h2>
        <p>請參考以下影片進行註冊與基本操作教學：</p>
        <div class="video-wrapper">
          <iframe
            src="https://www.youtube.com/embed/8YznMFowJvo"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      </section>

      <!-- FAQ 2~7 -->
      <section id="q2">
        <h2>為什麼選擇虔智科技？</h2>
        <p><strong>還在為傳統 DVR 畫質差、找不到影片浪費時間煩惱嗎？</strong><br>
        使用 <strong>video.qianchih.net</strong>，1秒找到影片、支援 4K 清晰錄影、多元觸發，提升出貨效率與風控。</p>
      </section>

      <section id="q3">
        <h2>🌟 核心功能亮點</h2>
        <ul>          
          <li><strong>1. 4K 高畫質 webm 格式錄影</strong>，內容細節不失真</li>
          <li><strong>2. 條碼／訂單編號觸發錄影</strong>，影片自帶浮水印標籤</li>
          <li><strong>3. 本地儲存＋快速查找</strong>，不用依賴傳統DVR</li>
          <li><strong>4. 純網頁操作，免安裝</strong>，Windows 開啟瀏覽器即可</li>
          <li><strong>5. 使用起來月租制入手門檻些對低，創業壓力小，功能持續更新</strong>，穩定不中斷</li>
          <li><strong>6. 多瀏覽器相容，快速搜尋操作</strong></li>
        </ul>
      </section>

      <section id="q4">
        <h2>🎛️ 支援格式與硬體建議</h2>
        <table>
          <thead>
            <tr><th>項目</th><th>建議規格</th></tr>
          </thead>
          <tbody>
            <tr><td>作業系統</td><td>Windows 10 或以上</td></tr>
            <tr><td>處理器</td><td>Intel i5 / Ryzen 3 以上</td></tr>
            <tr><td>顯示卡</td><td>支援 VP9，如 GTX1050、UHD 620</td></tr>
            <tr><td>記憶體</td><td>建議 8 GB</td></tr>
            <tr><td>儲存裝置</td><td>SSD，錄影使用 webm/mp4</td></tr>
            <tr><td>網路</td><td>穩定寬頻，支援 4K 串流</td></tr>
          </tbody>
        </table>
      </section>

      <section id="q5">
        <h2>📊 解析度比較一覽</h2>
        <table>
          <thead>
            <tr><th>解析度</th><th>畫素</th><th>細節辨識</th><th>適用場景</th></tr>
          </thead>
          <tbody>
            <tr><td>720p</td><td>1280×720</td><td>基本辨識</td><td>入門監控</td></tr>
            <tr><td>1080p</td><td>1920×1080</td><td>清晰畫質</td><td>標準用途</td></tr>
            <tr><td>2K</td><td>2560×1440</td><td>細節豐富</td><td>中高階</td></tr>
            <tr><td>4K</td><td>3840×2160</td><td>無失真辨識</td><td>專業稽核</td></tr>
          </tbody>
        </table>
      </section>

      <section id="q6">
        <h2>🏆 適用場景</h2>
        <ul>
          <li>電商倉儲／出貨中心</li>
          <li>高價品寄送與退貨驗證</li>
          <li>內部稽核與客訴影片存證</li>
          <li>品牌形象與流程透明性強化</li>
        </ul>
      </section>

      <section id="q7">
        <h2>✨ 使用後效益</h2>
        <ul>
          <li>✅ 條碼掃描即觸發錄影，自動命名、浮水印</li>
          <li>✅ 影片即錄即查，節省時間</li>
          <li>✅ 高畫質清楚對帳查核</li>
          <li>✅ 系統穩定、雲端剪輯與備份</li>
        </ul>
      </section>

      <!-- 返回按鈕 -->
      <button @click="gohome">返回</button>

    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  background-color: #000000;
  min-height: 100vh;
  color: white;
}
.content {
  max-width: 960px;
  text-align: center;
  font-size: 18px;
}

/* 影片樣式 */
.video-wrapper {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  margin-top: 20px;
  margin-bottom: 30px;
}
.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* 表格樣式 */
table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  background-color: #000;
  color: white;
  font-size: 18px;
}
th, td {
  border: 1px solid #444;
  padding: 10px;
}
th {
  background-color: #444;
  font-size: 20px;
}

/* 下拉選單 */
select {
  padding: 10px;
  font-size: 18px;
  margin-bottom: 2rem;
  width: 300px;
  border-radius: 8px;
}

/* 按鈕樣式 */
button {
  margin-top: 30px;
  border-radius: 10px;
  border: none;
  color: white;
  font-size: 20px;
  background-color: deeppink;
  width: 400px;
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}
button:hover {
  transform: scale(1.04);
}
</style>
